// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__19yPe","logoWrapper":"style_logoWrapper__jD3O6","titleWrapper":"style_titleWrapper__1C_oM","button":"style_button__eRTXd"};